import Container from '@atoms/Container';
import Layout from '@components/Layout';
import FranchiseReviewsSlider from '@sections/FranchiseReviewsSlider';
import SplitHero from '@sections/SplitHero';
import paddingDefault from '@utils/paddingDefault';
import { graphql } from 'gatsby';
import React from 'react';
import ServicesWeProvide from '../components/blocks/ServicesWeProvide';
import { colors } from '../components/primitives/colors/index.tsx';
import RichText from '../components/primitives/richtext/index.tsx';
import Seo from '../components/utils/Seo';
import CtaProvider from '../contexts/franchise/cta-provider.tsx';

// HERO CONTENT
// -------------------
const HeroContent = () => (
    <div css={styles.heroContentOutterWrap}>
        <div css={styles.heroContentInnerWrap}>
            <h4 css={styles.heroContentHeading}>
                Call Today
                {' '}
                <br />
                {' '}
                24/7 Emergency Services
            </h4>
        </div>
    </div>
);
// ABOUT ME SECTION
// ----------
const UnderHeroSection = ({ content, headline, subheading }) => (
    <div css={[paddingDefault(), styles.background]}>
        <Container>
            <h2 css={styles.franchisePageHeading}>{headline}</h2>
            <h4 css={styles.underHeroSectionSubheading}>{subheading}</h4>
            <RichText css={styles.copy} maxLength={4}>
                {content}
            </RichText>
        </Container>
    </div>
);

const LocalCity = ({ data }) => {
    const {
        content,
        state,
        city,
    } = data?.targetCity || {};

    if (!content) return null;

    const { cmsMetroStateSections: { image: heroImage } } = data;

    const {
        allFranchiseTestimonial: { nodes: testimonials },
        franchise,
    } = data;

    const franchiseData = data.franchise;
    const { filteredServices, permalink } = franchiseData;

    const filteredServicesWithLocalCityPermalink = filteredServices.map(filteredService => ({ ...filteredService, franchiseLink: `${permalink}${filteredService.franchiseLink}` }));
    const servicesWeProvidePageData = { algoliaFranchiseLocations: { data: franchiseData, filteredServices: filteredServicesWithLocalCityPermalink } };

    const selected = testimonials.slice(0, 6);

    const local_cta_data = {
        geo: {
            city: city.trim(),
            stateShort: state.trim(),
        },
        franchise,
    };

    return (
        <CtaProvider
            hideNationalCallCenter={!local_cta_data?.franchise?.tempOutOfService}
            hideFranchiseLink={!!local_cta_data?.franchise?.tempOutOfService}
        >
            <Layout
                localCtaData={local_cta_data}

            >
                <Seo
                    title={`${city} Fire and Water Damage Restoration and Cleaning Services`}
                    description={`SERVPRO provides ${city} with a fast response for home and business cleaning and restoration including water damage cleanup, fire damage and mold.`}
                    imageUrl={heroImage?.url}
                />
                <SplitHero
                    data={{
                        heading: `${city} Cleanup and Restoration`,
                        image: heroImage,
                        subheading: 'Commercial and Residential Damage Cleanup and Repair',
                        has_location_widget: !local_cta_data?.franchise?.tempOutOfService,
                    }}
                    localCtaData={local_cta_data}
                >
                    <HeroContent />
                </SplitHero>
                <UnderHeroSection
                    headline={`When Water, Fire, and Storm Damage Happens in ${city}, We're Ready.`}
                    subheading={`Whether you're looking for restoration, cleaning or construction services in ${city}, we're here to help 24/7.`}
                    content={content}
                />
                <ServicesWeProvide
                    data={{ title: 'Services We Provide' }}
                    pageData={servicesWeProvidePageData}
                    visitSiteCtaHref={franchise.permalink}
                />
                <FranchiseReviewsSlider data={{ slides: selected, city }} />
            </Layout>
        </CtaProvider>
    );
};
export default LocalCity;

const styles = {
    heroContentOutterWrap: {
        marginTop: '1.25rem',
        color: colors.grey800,
    },
    heroContentInnerWrap: {
        marginBottom: '1.25rem',
    },
    heroContentHeading: {
        marginBottom: '0.5rem',
        fontSize: '1.25rem',
        lineHeight: '1.75rem',
        color: colors.primaryOrange,
    },
    background: {
        backgroundColor: colors.grey100,
    },
    copy: {
        fontSize: '1.125rem',
        lineHeight: '1.75rem',
        '@media (min-width: 1024px)': {
            fontSize: '1.25rem',
            lineHeight: '1.75rem',
        },
    },
    underHeroSectionSubheading: {
        marginBottom: '0.5rem',
        fontSize: '1.25rem',
        lineHeight: '1.75rem',
        color: colors.primaryOrange,
    },
    franchisePageHeading: {
        fontSize: '36px',
        marginBottom: '1rem',
        lineHeight: 1.25,
        '@media (min-width: 1024px)': {
            marginBottom: '1.5rem',
        },
    },
    readMoreWrap: {
        marginTop: '1rem',
    },
    readMore: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: '4px',
    },
    iconArrowBack: {
        marginRight: '4px',
    },
    IconArrow: {
        marginLeft: '4px',
    },
};

export const query = graphql`
    query LocalCity($franchiseNumber: Int, $id: String) {
        franchise(franchiseNumber: { eq: $franchiseNumber }) {
            ...FranchiseMicrositeData
        }
        targetCity(id: { eq: $id }) {
            franchiseNumber
            countryLong
            country
            content
            city
            state
            stateLong
            franchises {
                
                filteredServices {
                    serviceType {
                        title
                        sort
                        franchise_service_mapping
                        link {
                            href
                            title
                        }
                        icon {
                            title
                            url
                        }
                        publish_details {
                            locale
                        }
                    }
                    franchiseLink
                }
                permalink
            }
        }
        allFranchiseTestimonial(filter: { franchiseNumber: { eq: $franchiseNumber }}) {
          nodes {
                ...AllFranchiseTestimonialData
          }
        }
        cmsMetroStateSections {
            image {
                filename
                title
                url
                description
                contentStackAsset(width: 720)
            }
        }
    }
`;
